<template>
  <v-container>
    <v-layout align-center justify-center row fill-height>
      <v-card class="style1">
        <v-img :src="image1" aspect-ratio="2.75"></v-img>
        <v-card-title>Te damos la bienvenida a Gestión 2030.</v-card-title>
        <v-card-title>Ingresa los datos solicitados para cambiar la contraseña temporal que te enviamos a tu correo.</v-card-title>
        <v-card-actions>
          <v-container>
            <v-layout row>
              <v-flex sx8>
                <form>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="glyphicon glyphicon-user"></i>
                    </span>
                    <input
                      id="mail"
                      type="email"
                      class="form-control"
                      name="mail"
                      v-model="email"
                      placeholder="Ingrese su email"
                      autocomplete="off"
                    />
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="glyphicon glyphicon-lock"></i>
                    </span>
                    <input
                      id="passwordTemp"
                      type="text"
                      class="form-control"
                      name="passwordTemp"
                      v-model="passwordTemp"
                      placeholder="Ingrese la contraseña enviada a su correo"
                      autocomplete="off"
                    />
                  </div>
                  <br />
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="glyphicon glyphicon-lock"></i>
                    </span>
                    <input
                      id="pass"
                      type="password"
                      class="form-control"
                      name="pass"
                      v-model="pass"
                      placeholder="Ingrese su contraseña nueva contraseña"
                      autocomplete="new-password"
                    />
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="glyphicon glyphicon-lock"></i>
                    </span>
                    <input
                      id="repassword"
                      type="password"
                      class="form-control"
                      name="repassword"
                      v-model="repassword"
                      placeholder="Reingrese nueva contraseña"
                      autocomplete="new-password"
                    />
                  </div>
                </form>
              </v-flex>
            </v-layout>
            <v-btn color="#EB7704" @click="sendResquest" :loading="loading">Entrar</v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>


<script>
import image1 from "../../../src/assets/CABECERA LOGIN.png";
import jwtDecode from "jwt-decode";

export default {
  data() {
    return {
      image1: image1,
      repassword: "",
      pass: "",
      passwordTemp: "",
      email: "",
      loading: false,
      error: false,
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      }
    };
  },

  mounted() {},

  methods: {
    logout() {
      this.$session.destroy();
      this.$router.push("/");
    },
    sendResquest() {
      this.loading = true;
      if (this.pass == "" || this.repassword == "" || this.email== "" || this.passwordTemp == "") {
        alert("No pueden haber campos vacios.");
        this.loading = false;
      } else {
        if (this.pass == this.repassword) {
          const newUser = {
            correo: this.email,
            provisoria: this.passwordTemp,
            passNueva: this.pass,
            passNuevaConfirmacion: this.repassword
          };
          axios
            .post(
              process.env.ROOT_API + "/user/loginProvisorio",
              newUser,
              this.auth
            )
            .then(response => {
              //console.log(response.data);
              alert("El cambio ha sido exitoso");
              this.logout();
            })
            .catch(error => {
              //console.log(error.response)
                alert(
                  error.response.data
                );
                this.pass = "";
                this.repassword = "";
                this.loading = false;

              
            });
        } else {
          alert("Las contraseñas no coinciden");
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style scoped>
.style1 {
  width: 50%;
}

.v-card__actions .v-btn,
.v-card__actions > * {
  margin-top: 5%;
}

.new-alert {
  width: 400px;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/inicio/UnknowPassword.vue